'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import {
  CollectionReveal,
  Scene_js,
  Scene_As,
  V,
  Scene_Ns,
} from './collection-artifact-primitives';
import { Uc, Qc, Zc, Gc, Yc, Kc } from './collection-materials';
import { ArtifactStatus } from './playback-controls';
import { fe } from './reference-products';
export function ResearchFinding({
  piece: e,
  story: t,
  starts: n,
  t: r,
  on: i,
  className: a,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <CollectionReveal on={i} scale={0.98} className={`h-full ${a}`}>
      <article
        className={
          'sf grid h-full grid-cols-[88px_minmax(0,1fr)] gap-3 rounded-[14px] p-2 md:grid-cols-1 md:content-start md:gap-0'
        }
      >
        <Scene_js
          piece={e}
          className={'aspect-square rounded-[10px] md:aspect-[16/10]'}
        />
        <div className={'min-w-0 md:px-1.5 md:pt-3 md:pb-1'}>
          <h3 className={'text-ink text-[14px] leading-5 font-medium'}>
            {translateShowcaseNode(showcaseCopy, e.style)}
            <span
              className={
                'text-ink-3 block truncate text-[12px] leading-4 font-normal'
              }
            >
              {translateShowcaseNode(showcaseCopy, e.name)}
            </span>
          </h3>
          <p className={'mt-1 flex items-center gap-2'}>
            <CollectionReveal
              as={'span'}
              on={r >= (n[0] ?? 0) - 200}
              y={0}
              scale={0.9}
              className={
                'text-ink-2 inline-flex h-5 shrink-0 items-center rounded-[6px] px-1.5 text-[11px] font-medium shadow-[inset_0_0_0_1px_var(--line-strong)]'
              }
            >
              {translateShowcaseNode(showcaseCopy, e.role)}
            </CollectionReveal>
            <span
              className={
                'text-ink-3 flex min-w-0 items-center gap-1.5 text-[11.5px] leading-4'
              }
            >
              <Scene_As hex={e.colour.hex} className={'size-2'} />
              <span className={'truncate'}>
                {translateShowcaseNode(showcaseCopy, e.colour.name)}
              </span>
            </span>
          </p>
          <dl className={'mt-1.5 flex flex-col gap-1 md:mt-2 md:gap-1.5'}>
            {translateShowcaseNode(
              showcaseCopy,
              t.fields.map(([e, t], i) => {
                let a = n[i] ?? 0,
                  o = Math.max(0, Math.min(t.length, Math.floor((r - a) / Uc))),
                  s = r >= a && o < t.length;
                return (
                  <div
                    key={e}
                    className={
                      'grid grid-cols-[62px_minmax(0,1fr)] gap-2 md:grid-cols-1 md:gap-0'
                    }
                  >
                    <dt
                      className={
                        'text-ink-4 text-[11.5px] leading-[17px] transition-opacity duration-200'
                      }
                      style={{
                        opacity: r >= a ? 1 : 0.35,
                      }}
                    >
                      {translateShowcaseNode(showcaseCopy, e)}
                    </dt>
                    <dd
                      className={
                        'text-ink-2 relative min-h-[17px] text-[12.5px] leading-[17px]'
                      }
                    >
                      <span className={'sr-only'}>
                        {translateShowcaseNode(showcaseCopy, t)}
                      </span>
                      <span aria-hidden={!0} className={'invisible'}>
                        {translateShowcaseNode(showcaseCopy, t)}
                      </span>
                      <span aria-hidden={!0} className={'absolute inset-0'}>
                        {translateShowcaseNode(showcaseCopy, t.slice(0, o))}
                        {translateShowcaseNode(
                          showcaseCopy,
                          s ? <span className={'caret'} /> : null
                        )}
                      </span>
                    </dd>
                  </div>
                );
              })
            )}
          </dl>
        </div>
      </article>
    </CollectionReveal>
  );
}
export function CollectionStories({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = V.filter((t, n) => e >= Qc(n)).length;
  return (
    <div className={'flex h-full flex-col'}>
      <ArtifactStatus
        icon={'doc'}
        title={translateShowcaseNode(
          showcaseCopy,
          'LISI\xC8RE FW27 product stories'
        )}
        done={e >= Zc}
        working={'Writing stories'}
        doneLabel={'Stories saved'}
      />
      <div
        className={
          'grid flex-1 content-start gap-3 p-3 sm:p-5 md:grid-cols-3 md:gap-4 md:p-6'
        }
      >
        {translateShowcaseNode(
          showcaseCopy,
          Gc.map((t, n) => {
            let r = V[t.piece],
              i = Yc[n];
            return !r || !i ? null : (
              <ResearchFinding
                key={r.name}
                piece={r}
                story={t}
                starts={i.starts}
                t={e}
                on={e >= (Kc[n] ?? 0)}
                className={n === 2 ? 'max-sm:hidden' : ''}
              />
            );
          })
        )}
      </div>
      <div
        className={
          'flex shrink-0 items-center gap-3 px-3 pb-3 sm:px-5 sm:pb-5 md:px-6'
        }
      >
        <p className={'label shrink-0'}>
          <span className={'num text-ink'}>
            {translateShowcaseNode(showcaseCopy, t)}
          </span>
          {translateShowcaseNode(showcaseCopy, ' of ')}
          {translateShowcaseNode(showcaseCopy, V.length)}
          {translateShowcaseNode(showcaseCopy, ' stories')}
        </p>
        <div className={'flex min-w-0 flex-1 justify-end gap-1.5'}>
          {translateShowcaseNode(
            showcaseCopy,
            V.map((t, n) => {
              let r = e >= Qc(n);
              return (
                <span key={t.name} className={'relative shrink-0'}>
                  <Scene_js
                    piece={t}
                    className={`size-8 rounded-[7px] transition-opacity duration-300 sm:size-9 ${r ? '' : 'opacity-40'}`}
                  />
                  <span
                    className={
                      'absolute -right-1 -bottom-1 grid size-4 place-items-center rounded-full bg-[var(--primary)] text-[var(--primary-foreground)] shadow-[0_0_0_2px_var(--canvas)] transition-[opacity,transform] duration-200 ease-[var(--ease)]'
                    }
                    style={{
                      opacity: +!!r,
                      transform: r ? 'none' : 'scale(0.6)',
                    }}
                  >
                    <Scene_Ns on={r} className={'size-3'} />
                  </span>
                </span>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
export const tl = fe;
export const nl = {
  Silhouette: 5,
  Fabrics: 0,
  Yarns: 4,
  Colour: 3,
};
export const rl = 250;
export const il = (e) => 750 + e * 450;
export const al = 2600;
export const ol = (e) => 3300 + e * 220;
export const sl = ol(tl.sources.length - 1);
export const cl = sl + 900;
